import * as Types from '../../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type SideNavigationOrganizationFragment = { __typename: 'Organization', id: string, name?: string | null, type?: Types.OrganizationType | null, organizationGroup?: { __typename: 'OrganizationGroup', id: string, organizations: Array<{ __typename: 'Organization', id: string, name?: string | null, isActive: boolean }> } | null };

export type SideNavigationAllOrganizationsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.OrganizationFilterInput>;
}>;


export type SideNavigationAllOrganizationsQuery = { __typename: 'Query', organizations: Array<{ __typename: 'Organization', id: string, name?: string | null, type?: Types.OrganizationType | null, organizationGroup?: { __typename: 'OrganizationGroup', id: string, organizations: Array<{ __typename: 'Organization', id: string, name?: string | null, isActive: boolean }> } | null } | null> };

export type SideNavigationUserMembershipsQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type SideNavigationUserMembershipsQuery = { __typename: 'Query', user: { __typename: 'User', memberships: Array<{ __typename: 'Membership', id: string, role: Types.MembershipRole, organization: { __typename: 'Organization', id: string, name?: string | null, type?: Types.OrganizationType | null, organizationGroup?: { __typename: 'OrganizationGroup', id: string, organizations: Array<{ __typename: 'Organization', id: string, name?: string | null, isActive: boolean }> } | null } }> } };

export type SideNavigationColormassOrganizationQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SideNavigationColormassOrganizationQuery = { __typename: 'Query', organizations: Array<{ __typename: 'Organization', id: string, name?: string | null, type?: Types.OrganizationType | null, organizationGroup?: { __typename: 'OrganizationGroup', id: string, organizations: Array<{ __typename: 'Organization', id: string, name?: string | null, isActive: boolean }> } | null } | null> };

export type CreateProfilePictureAssignmentMutationVariables = Types.Exact<{
  input: Types.MutationCreateDataObjectAssignmentInput;
}>;


export type CreateProfilePictureAssignmentMutation = { __typename: 'Mutation', createDataObjectAssignment: { __typename: 'DataObjectAssignment', id: string } };

export type SideNavigationRenderServerDownloadsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SideNavigationRenderServerDownloadsQuery = { __typename: 'Query', renderServerDownloads: Array<{ __typename: 'RenderServerDownload', target: string, version: string, url: string }> };

export const SideNavigationOrganizationFragmentDoc = gql`
    fragment SideNavigationOrganization on Organization {
  id
  name
  type
  organizationGroup {
    id
    organizations {
      id
      name
      isActive
    }
  }
}
    `;
export const SideNavigationAllOrganizationsDocument = gql`
    query sideNavigationAllOrganizations($filter: OrganizationFilterInput) {
  organizations(filter: $filter, take: 9999) {
    ...SideNavigationOrganization
  }
}
    ${SideNavigationOrganizationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SideNavigationAllOrganizationsGQL extends Apollo.Query<SideNavigationAllOrganizationsQuery, SideNavigationAllOrganizationsQueryVariables> {
    override document = SideNavigationAllOrganizationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SideNavigationUserMembershipsDocument = gql`
    query sideNavigationUserMemberships($id: ID!) {
  user(id: $id) {
    memberships {
      id
      organization {
        ...SideNavigationOrganization
      }
      role
    }
  }
}
    ${SideNavigationOrganizationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SideNavigationUserMembershipsGQL extends Apollo.Query<SideNavigationUserMembershipsQuery, SideNavigationUserMembershipsQueryVariables> {
    override document = SideNavigationUserMembershipsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SideNavigationColormassOrganizationDocument = gql`
    query sideNavigationColormassOrganization {
  organizations(filter: {url: {equals: "colormass"}}) {
    ...SideNavigationOrganization
  }
}
    ${SideNavigationOrganizationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SideNavigationColormassOrganizationGQL extends Apollo.Query<SideNavigationColormassOrganizationQuery, SideNavigationColormassOrganizationQueryVariables> {
    override document = SideNavigationColormassOrganizationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateProfilePictureAssignmentDocument = gql`
    mutation CreateProfilePictureAssignment($input: MutationCreateDataObjectAssignmentInput!) {
  createDataObjectAssignment(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateProfilePictureAssignmentGQL extends Apollo.Mutation<CreateProfilePictureAssignmentMutation, CreateProfilePictureAssignmentMutationVariables> {
    override document = CreateProfilePictureAssignmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SideNavigationRenderServerDownloadsDocument = gql`
    query sideNavigationRenderServerDownloads {
  renderServerDownloads {
    target
    version
    url
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SideNavigationRenderServerDownloadsGQL extends Apollo.Query<SideNavigationRenderServerDownloadsQuery, SideNavigationRenderServerDownloadsQueryVariables> {
    override document = SideNavigationRenderServerDownloadsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }